import { t } from '@lingui/macro';
import { connect } from 'react-redux';
import styles from '../FilterSidebar.module.css';
import AspectLegendStyles from './AspectLegend.module.css';

const AspectLegendComponent = ({ terrainMode }) => {
    if (terrainMode !== 'aspect') {
        return null;
    }
    // Standard compass orientation: N up, E right, S down, W left
    // Angles go clockwise in visual representation
    const directions = [
        { name: 'N',  angle: 90,  color: '#84d600' },
        { name: 'NE', angle: 45,  color: '#00ab44' },
        { name: 'E',  angle: 0,   color: '#0068c0' },
        { name: 'SE', angle: 315, color: '#6c00a3' },
        { name: 'S',  angle: 270, color: '#ca009c' },
        { name: 'SW', angle: 225, color: '#ff5568' },
        { name: 'W',  angle: 180, color: '#ffab47' },
        { name: 'NW', angle: 135, color: '#f4fa00' },
    ];
    const circleSize = 100;
    const circlePadding = 15;
    return (
        <div className={AspectLegendStyles.wrapper}>
            <div className={styles.legHead}>{t`Экспозиция`}:</div>
            <div
                className={AspectLegendStyles.container}
                style={{
                    position: 'relative',
                    width: '170px',
                    height: '170px',
                    margin: '0 auto',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '35px',
                        left: '35px',
                        width: `${circleSize}px`,
                        height: `${circleSize}px`,
                        borderRadius: '50%',
                        background: `conic-gradient(from 0deg, ${directions.map(dir => dir.color).join(', ')}, ${directions[0].color})`,
                    }}
                >
                </div>
                <svg
                    style={{
                        position: 'absolute',
                        top: 'calc(35px - 10px)',
                        left: 'calc(35px - 10px)',
                        width: `${circleSize + 20}px`,
                        height: `${circleSize + 20}px`,
                        pointerEvents: 'none',
                    }}
                    viewBox={`-10 -10 ${circleSize + 20} ${circleSize + 20}`}
                >
                    {directions.map((dir, idx) => {
                        const angle = (dir.angle - 90 + 22.5) * (Math.PI / 180);
                        const centerX = circleSize / 2;
                        const centerY = circleSize / 2;
                        const radius = circleSize / 2 + 10;
                        const x2 = centerX + radius * Math.cos(angle);
                        const y2 = centerY + radius * Math.sin(angle);
                        return (
                            <line
                                key={`divider-${idx}`}
                                x1={centerX}
                                y1={centerY}
                                x2={x2}
                                y2={y2}
                                stroke="white"
                                strokeWidth="1.5"
                                opacity="0.5"
                            />
                        );
                    })}
                </svg>
                {directions.map(dir => {
                    const angle = dir.angle * (Math.PI / 180);
                    const labelRadius = circleSize / 2 + circlePadding;
                    const x = 35 + circleSize / 2 + labelRadius * Math.cos(angle);
                    const y = 35 + circleSize / 2 - labelRadius * Math.sin(angle);
                    const isCardinal = dir.name.length === 1;
                    return (
                        <div
                            key={`label-${dir.name}`}
                            style={{
                                position: 'absolute',
                                left: `${x}px`,
                                top: `${y}px`,
                                transform: 'translate(-50%, -50%)',
                                color: '#fff',
                                textShadow: '0px 0px 2px rgba(51, 51, 51, 0.5)',
                                fontWeight: isCardinal ? 'bold' : 'normal',
                                fontSize: '11px',
                            }}
                        >
                            {dir.name}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
const mapStateToProps = ({ map: { terrainMode } }) => ({ terrainMode });

export const AspectLegend = connect(mapStateToProps)(AspectLegendComponent);
